module.exports = __webpack_public_path__ + "static/media/aaapv.7e9e6ded.svg";